

















































































import { mixins } from 'vue-class-component';
import DatasourceServices, { DatasourceDto } from '@/services/datasource';
import BasePageMixin from '@/mixins/base-page-mixin';
import { FilterItem } from '@/interfaces/filter-items';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
import ColumnConfig from '../../components/column-config.vue';
import PermConfig from '../../components/permission-config.vue';
@Component({
  components: { ColumnConfig, PermConfig }
})
export default class TableConfig extends mixins(BasePageMixin) {

  dsSrv = new DatasourceServices();
  childShow = true;
  selectedRowKeys: number[] = [];
  tableId: number = 0;
  loading = false;
  showColumnSettings = false;
  showPrivilegeSettings = false; 
  showDrawer = true;
  filterItems: FilterItem[] = [
    {
      label: '表物理名',
      key: 'tableNameEn_like',
      type: 'input'
    }
  ];
  columns = [{
      title: '表物理名',
      dataIndex: 'tableNameEn',
      key: 'tableNameEn',
      width: 120,
    },
    {
      title: '表逻辑名',
      dataIndex: 'tableNameCn',
      key: 'tableNameCn',
      width: 120,
      scopedSlots: { customRender: 'nameCn' },
    },
    {
      title: '输入',
      dataIndex: 'inputFlag',
      key: 'inputFlag',
      width: 50,
      scopedSlots: { customRender: 'inputFlag' },
    },
    {
      title: '输出',
      dataIndex: 'outputFlag',
      key: 'outputFlag',
      width: 50,
      scopedSlots: { customRender: 'outputFlag' },
    },
    {
      title: '启用',
      dataIndex: 'status',
      key: 'status',
      width: 50,
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 140,
      scopedSlots: { customRender: 'operation' },
    },
  ];

  onSelectChange(selectedRowKeys: []) {
    this.selectedRowKeys = selectedRowKeys;
  }
  dbNames = [];
  data = [];
  colData = [];
  id: any = 0;
  formData: DatasourceDto = {dsType: '',  dsConfig: {}, fileConfig: {}, esConf: {}, ossConfig: {}, kafkaConf: {}, kafkaConfDto: {}, hiveConf: {}, restConfig: {}, dorisConf: {}, columnConfig: []} ;
  async created() {
    //获取数据
    this.id = this.$route.query.id ;
    if (this.id) {
      let tableRes = await this.dsSrv.tables({sourceId_eq: this.id});
      if (tableRes && tableRes.length === 0) {
        tableRes = this.dsSrv.initTables(this.id);
      }
      this.data = tableRes;
      

    }
  }
  async getDataList(filter:any) {
    let params = {sourceId_eq: this.id}
    if (filter) {
      params = Object.assign(params, filter);
    }
    this.data = await this.dsSrv.tables(params);
    this.childShow= false;
    this.$nextTick(() => {
        this.childShow= true;
    });
    let info = await this.dsSrv.getInfo(this.id);
    if (info) {
      this.formData = info;
    }
    

  }
  
  async onDelete(ids: number[]) {

    let res = await this.dsSrv.deleteTables(ids);
    this.getDataList(null);
  }
  async onCellChange(args: string[], record:any, column:string) {
    record[column] = args[0]
    let cfg = {...record}
    let res = await this.dsSrv.updateTable(cfg)
  }

  /**  权限 操作 ************/
  async privilegeSetting(id: number) {
    this.tableId = id;
    this.showPrivilegeSettings = true;
  }
  async afterPermVisibleChange(val:any) {
    
    if (val) {
      this.showDrawer= false;
      this.$nextTick(() => {
        this.showDrawer= true;
      });

    }
  }
  onPermClose(args: any) {
    this.showPrivilegeSettings = false;
  }

/********** 配置 操作*************/
  async columnSetting(id: number) {
    this.tableId = id;
    this.showColumnSettings = true;
    
  }
  async afterColVisibleChange(val:any) {
    
    if (val) {
      this.showDrawer= false;
      this.$nextTick(() => {
        this.showDrawer= true;
      });
    }
    
  }
    
  onColClose(args: any) {
    this.showColumnSettings = false;
  }
  /** Filter */
  excuteFilter(res: any) {
    this.getDataList(res);
  }

  /** router */
    @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/data/datasource/tableconfig') return false;
    this.getDataList(null);
  }
  handleBatch(args: any) {
    if (args.key == 'removeAll') {
      this.onDelete(this.selectedRowKeys);
    }
  }
  async initTables() {
    this.loading = true;
    this.data = await this.dsSrv.initTables(this.id);
    this.loading = true;
  }

}
